import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';
import { StyledDataGrid } from "./StyledDataGrid";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { getRoleData } from "../Store/Role/role-action";
import Cookies from "js-cookie";
import { pdf } from "@react-pdf/renderer";
import OnlineStudentReport from "./Document/OnlineStudentReport";



const OnlineStudent = () => {
    const [course, setCourse] = useState([])
    const [vendordata, setVendorData] = useState([])

    const [value, setValue] = useState({
        Course_Id: "",
        fromdate: "",
        todate: "",
        admission: "",
    })

    const getCourseData = () => {

        const data = {
            tablename: "Course_Mst",
            columnname: "Course_Id,Course_Name"
        }

        axios.post(`${BASE_URL}/get_new_data`, data)
            .then((res) => {
                console.log(res.data)
                setCourse(res.data)
            })
            .catch((err) => {
                console.log(err)
            })

    }

    useEffect(() => {
        getCourseData()
    }, [])

    const [pdfdata, setpdfData] = useState([]);

    async function getDetails() {
        const param = {
            // gen_id: generateresultid,
            Course_Id: value.Course_Id,
            fromdate: value.fromdate,
            todate: value.todate,
            admission: value.admission
        };

        axios.post(`${BASE_URL}/getonlinestudentreport`, param).then((res) => {
            setpdfData(res.data);
            onlinestudentreport(res.data)
        });
    }

    const onlinestudentreport = async (data) => {
        const blob = await pdf(<OnlineStudentReport data={data} />).toBlob();
        const url = URL.createObjectURL(blob);
        window.open(url);
        URL.revokeObjectURL(url);
    };





    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const roledata = {
        role: Cookies.get(`role`),
        pageid: 45,
    };

    const dispatch = useDispatch();
    const roleaccess = useSelector((state) => state.roleAssign?.roleAssign[0]?.accessid);

    useEffect(() => {
        dispatch(getRoleData(roledata));
    }, []);


    return (

        <div class="container-fluid page-body-wrapper ">
            <InnerHeader />
            <div class="main-panel">
                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title">Online Student</h4>
                                    <hr></hr>
                                    <form class="forms-sample py-3">
                                        <div class='row'>

                                            <div class="form-group col-lg-3">
                                                <label for="exampleFormControlSelect1">Select Course<span className='text-danger'>*</span> </label>
                                                <select class="form-control" id="exampleFormControlSelect1"
                                                    value={value.Course_Id} name='Course_Id' onChange={onhandleChange}>
                                                    <option>Select Course</option>
                                                    {(Array.isArray(course) ? course : []).filter((c) => c && c.IsDelete != 1 && c.isDelete != 1 && c.deleted != 1).map((item) => {
                                                        return (
                                                            <option value={item.Course_Id}>{item.Course_Name}</option>

                                                        )
                                                    })}
                                                </select>
                                                {/* {<span className="text-danger"> {error.course} </span>} */}
                                            </div>

                                            <div class="form-group col-lg-3">
                                                <label for="exampleFormControlSelect1">Admission Status<span className='text-danger'>*</span> </label>
                                                <select class="form-control form-control-lg" id="exampleFormControlSelect1" value={value.admission}
                                                    onChange={onhandleChange} name='admission'>
                                                    <option value="">Select</option>
                                                    <option value="9">Accepted</option>
                                                    <option value="11">Denied</option>
                                                    <option value="2">Pending</option>


                                                </select>

                                                {/* {<span className="text-danger"> {error.admission} </span>} */}
                                            </div>
                                            <div class="form-group col-lg-3" style={{ display: 'flex', flexDirection: 'column' }}>
                                                <label for="exampleInputUsername1">From Date<span className='text-danger'>*</span></label>
                                                <DatePicker
                                                    selected={value.fromdate ? new Date(value.fromdate) : null}
                                                    onChange={(date) => onhandleChange({ target: { name: "fromdate", value: date } })}
                                                    className="form-control"
                                                    id="exampleInputUsername1"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select a date"
                                                />
                                                {/* {<span className="text-danger"> {error.fromdate} </span>} */}
                                            </div>

                                            <div class="form-group col-lg-3" style={{ display: 'flex', flexDirection: 'column' }}>
                                                <label for="exampleInputUsername1">To Date <span className='text-danger'>*</span></label>
                                                <DatePicker
                                                    selected={value.todate ? new Date(value.todate) : null}
                                                    onChange={(date) => onhandleChange({ target: { name: "todate", value: date } })}
                                                    className="form-control"
                                                    id="exampleInputUsername1"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select a date"
                                                />
                                                {/* {<span className="text-danger"> {error.todate} </span>} */}
                                            </div>




                                        </div>




                                        <button
                                            type="button"
                                            onClick={getDetails}
                                            class="btn btn-primary mr-2"
                                            disabled={
                                                !value.Course_Id ||
                                                value.Course_Id === "Select Course" ||
                                                !value.fromdate ||
                                                !value.todate ||
                                                !value.admission
                                            }>
                                            Show
                                        </button>
                                        <button type='button' onClick={() => {
                                            window.location.reload()
                                        }} class="btn btn-light">Cancel</button>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div >

    )
}

export default OnlineStudent